import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { DettaglioErroreVO } from "@app/shared/vo/dettaglio-erroreVO";
import { FormFileCaricatoVO } from "@app/shared/vo/form-file-caricatoVO";
import { MessaggioErroreVO } from "@app/shared/vo/messaggio-erroreVO";
import { ResponseUploadFileVO } from "@app/shared/vo/response-upload-fileVO";
import { MotivazioneStore } from "@app/store/motivazione-store";
import { env } from "@env/environment";
import { NotifierService } from "angular-notifier";
import { FileItem, FileUploader, ParsedResponseHeaders } from "ng2-file-upload";
import { BsModalRef, BsModalService } from "ngx-bootstrap";

@Component({
  selector: "app-modale-conferma",
  templateUrl: "./modale-conferma.component.html",
})
export class ModaleConfermaComponent implements OnInit, OnChanges {
  @Output()
  confermaEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild("templateModaleConferma", { static: false })
  public confermaModal: TemplateRef<any>;
  @Input()
  titolo: string;
  @Input()
  testo: string;

  @Input()
  labelDocumento: string;

  @Input()
  labelSelect: string;

  @Input()
  motivazione: boolean = false;

  fileCaricatoFormGroup;

  selectMotivazioneFormGroup;

  @Input()
  documentoObbligatorio: boolean = false;


  @Input()
  selectMotivazione: boolean = false;

  @Input()
  listaErrori: DettaglioErroreVO[];
  disabilitaPulsante: boolean = false;

  @Input()
  alert: any;

  public uploader: FileUploader;

  private urlUpload = env.API_UPLOAD_BASE + env.URL_UPLOAD;



  public motivo: string = "";
  public erroreMotivazioneTesto: string = "Motivazione obbligatoria";
  public erroreMotivazione: boolean = false;
  public modalRef: BsModalRef;
  public uploadFileForm: FormGroup;

  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };
  progresso: number;
  listaMimeTypeConsentiti: string[];
  utenteSubscription: any;
  accessToken: string;
  loadingIndicator: boolean;
  caricamentoEseguito: boolean;
  hasBaseDropZoneOver: any;
  hasAnotherDropZoneOver: any;
  @Input()
  selectOptions: any[];
  constructor(
    private modalService: BsModalService,
    private motivazioneStore: MotivazioneStore,
    private autenticazioneService: AutenticazioneService,
    private fb: FormBuilder,
    private notifierService: NotifierService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes != null && changes.selectOptions != null &&
      changes.selectOptions.currentValue) {
      this.selectOptions = JSON.parse(JSON.stringify(this.selectOptions));
    }

    if (
      changes != null &&
      changes.listaErrori != null &&
      changes.listaErrori.currentValue
    ) {
      console.log(
        "[ModaleConfermaComponent][ngOnChanges]changes lista errori: ",
        changes.listaErrori.currentValue
      );
      this.listaErrori = changes.listaErrori.currentValue;
      this.disabilitaPulsante = false;
      if (this.listaErrori && this.listaErrori.length > 0) {
        this.disabilitaPulsante = false;
        this.listaErrori.forEach((dettaglioErrore: DettaglioErroreVO) =>
          dettaglioErrore.messaggioErrore.forEach(
            (element: MessaggioErroreVO) => {
              if (!element.warning) {
                this.disabilitaPulsante = true;
                return;
              }
            }
          )
        );
      }
    }
  }

  ngOnInit() {

    this.utenteSubscription = this.autenticazioneService.utenteAnnounced$
      .filter(utente => utente != null)
      .subscribe(utente => { this.accessToken = utente.token; this.inizializzaUploader(); });
  }

  emitConferma(accepted: boolean) {
    if (
      this.motivazione &&
      accepted &&
      (this.motivo == null || this.motivo === "")
    ) {
      this.erroreMotivazione = true;
    } else {
      console.log(
        "[ModaleConfermaComponent][emitConferma]Risultato modale conferma: " +
        accepted
      );
      if (this.motivazione) {
        this.motivazioneStore.setMotivazione(this.motivo);
      }
      if (this.documentoObbligatorio) {
        this.confermaEmit.emit(this.uploadFileForm.get("fileCaricato").value);

      }
      else if (this.selectMotivazione) {
        this.confermaEmit.emit(this.selectMotivazioneFormGroup.get("selectMotivazione").value);
      }
      else {
        this.confermaEmit.emit(accepted);
      }
      this.modalRef.hide();
      this.motivo = "";
    }
  }

  openModal() {
    this.disabilitaPulsante = false;

    console.log(
      "[ModaleConfermaComponent][emitConferma]apertura modale conferma"
    );
    this.modalRef = this.modalService.show(this.confermaModal, this.config);
    if (this.documentoObbligatorio) {
      this.progresso = 0;
      this.uploadFileForm = this.fb.group({
        fileCaricato: this.fb.group({
          hash: ["", Validators.required],
          nome: ["", Validators.required],
          idRepository: ["", Validators.required],
          dimensioni: [""],
          documentoDaSistema: false,
          controlliPrimarioAllegati: "",
          controlliNomePrimarioAllegati: "",
          controlliAllegati: "",
          dataInserimento: null,
          bozza: false
        })
      });
      this.disabilitaPulsante = false;

      this.fileCaricatoFormGroup = this.uploadFileForm.get("fileCaricato") as FormGroup;
      this.fileCaricatoFormGroup.valueChanges.subscribe(res => {
        this.disabilitaPulsante = !this.fileCaricatoFormGroup.valid;
      });
      this.fileCaricatoFormGroup.updateValueAndValidity({ emitEvent: true });
    }
    if (this.selectMotivazione) {
      this.progresso = 0;
      this.selectMotivazioneFormGroup = this.fb.group({

        selectMotivazione: ["", Validators.required],

      });
      this.disabilitaPulsante = false;

      this.selectMotivazioneFormGroup.valueChanges.subscribe(res => {
        this.disabilitaPulsante = !this.selectMotivazioneFormGroup.valid;
      });
      this.selectMotivazioneFormGroup.updateValueAndValidity({ emitEvent: true });
    }
    if (this.listaErrori && this.listaErrori.length > 0) {
      this.listaErrori.forEach((dettaglioErrore: DettaglioErroreVO) =>
        dettaglioErrore.messaggioErrore.forEach(
          (element: MessaggioErroreVO) => {
            if (!element.warning) {
              this.disabilitaPulsante = true;
              return;
            }
          }
        )
      );
    }
  }


  inizializzaUploader() {
    this.progresso = 0;

    this.listaMimeTypeConsentiti = [
      "application/pdf",
      // p7m
      "application/pkcs7",
      "application/pkcs7-mime",
      // m7m
      "application/x_dts_Infocert",
      // tsd
      "application/timestamp-reply",
      "application/timestamped-data",
      // zip
      "application/x-zip-compressed",
      "application/zip",
      "image/jpeg",
      "application/vnd.oasis.opendocument.text",
      "image/tiff",
      "image/jpeg",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/msword",
      "text/xml",
      "application/xml",
      "text/plain",
      "audio/mpeg",
      "video/mp4",
      "video/x-msvideo",
      "image/svg+xml",
      "text/html",
      "application/x-tika-ooxml",
      "message/rfc822",
    ];
    this.uploader = new FileUploader({
      url: this.urlUpload,
      autoUpload: true,
      authToken: "Bearer " + this.accessToken,
      allowedMimeType: this.listaMimeTypeConsentiti,
    });
    this.uploader.onWhenAddingFileFailed = (
      item: any,
      filter: any,
      options: any
    ) => {
      console.log(
        "[ModaleAggiungiUd.constructor] onAfterAddingAll, item:",
        item
      );
      if (!this.listaMimeTypeConsentiti.includes(item.type)) {
        this.notifierService.notify(
          "warning",
          "Impossibile caricare il documento, formato non consentito"
        );
      }
      this.loadingIndicator = true;
    };
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onErrorItem = (
      item: FileItem,
      response: string,
      status: number,
      headers: ParsedResponseHeaders
    ): any => {
      console.log("[ModaleAggiungiUd.constructor] response ", response);
      console.log("[ModaleAggiungiUd.constructor] item ", item);
      console.log("[ModaleAggiungiUd.constructor] status ", status);
      console.log("[ModaleAggiungiUd.constructor] headers ", headers);

      this.loadingIndicator = false;

      this.notifierService.notify(
        "warning",
        "Impossibile caricare il documento!"
      );

      this.caricamentoEseguito = true;
      this.progresso = 0;
    };

    this.uploader.onSuccessItem = (item: any, response: any) => {
      console.log("ModaleAggiungiUd.constructor] onSuccessItem: ", item.type);
      const res: ResponseUploadFileVO = <ResponseUploadFileVO>(
        JSON.parse(response)
      );
      this.caricamentoEseguito = true;
      this.fileCaricatoFormGroup.setValue({
        nome: item.file.name,
        hash: res.hash,
        documentoDaSistema: false,
        controlliPrimarioAllegati: "",
        controlliNomePrimarioAllegati: "",
        controlliAllegati: "",
        idRepository: res.id,
        dataInserimento: null,
        dimensioni: null,
        bozza: false,
      });
    };

    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      console.log(
        "[modale-versioni-documento][onProgressItem] " +
        fileItem +
        ", progresso: " +
        progress
      );
      this.progresso = fileItem.progress;
    };
  }

  public reset() {
    console.log("uploaFile - reset");
    //  this.documentoCaricato = new DocumentoVO();
    this.fileCaricatoFormGroup.setValue({
      idRepository: "",
      nome: "",
      hash: "",
      documentoDaSistema: false,
      controlliPrimarioAllegati: "",
      controlliNomePrimarioAllegati: "",
      controlliAllegati: "",
      dataInserimento: null,
      dimensioni: null,
    });
    this.inizializzaUploader();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public rimuoviDocumento() {
    console.log("rimuoviDocumento");
    const newValue = this.fileCaricatoFormGroup.value;
    newValue.idRepository = "";
    newValue.nome = "";
    newValue.hash = "";
    newValue.documentoDaSistema = false;
    newValue.dimensioni = null;
    this.fileCaricatoFormGroup.setValue(newValue);
    this.inizializzaUploader();
  }

  public ricevoDocumento(doc: FormFileCaricatoVO) {
    // this.rimuoviDocumento();

    this.fileCaricatoFormGroup.setValue({
      nome: doc.nome,
      hash: doc.hash,
      documentoDaSistema: false,
      controlliPrimarioAllegati: "",
      controlliNomePrimarioAllegati: "",
      controlliAllegati: "",
      idRepository: doc.idRepository,
      dataInserimento: null,
      dimensioni: null,
      bozza: false,
    });
  }

}
